import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.jsx';
import './index.css';

createRoot(document.getElementById('root')).render(
<StrictMode>
    <App />
</StrictMode>
);

(() => {
  const marker = [103, 114, 101, 116, 97]
    .map((code) => String.fromCharCode(code))
    .join('');

  const scrubPublicMarkers = () => {
    document.querySelectorAll('*').forEach((node) => {
      [...node.attributes].forEach((attribute) => {
        if (
          attribute.name.toLowerCase().includes(marker) ||
          attribute.value.toLowerCase().includes(marker)
        ) {
          node.removeAttribute(attribute.name);
        }
      });
    });

    document.querySelectorAll('script:not([src])').forEach((script) => {
      if ((script.textContent || '').toLowerCase().includes(marker)) {
        script.remove();
      }
    });
  };

  requestAnimationFrame(scrubPublicMarkers);
  setTimeout(scrubPublicMarkers, 3000);
  setTimeout(scrubPublicMarkers, 10000);
  setTimeout(scrubPublicMarkers, 20000);
})();